import React from "react";

/**
 * A dimension line: perpendicular ticks at both ends, a 1px rule, and the
 * measured value centred on it. Never render one without a real value —
 * a dimension without a number is decoration, and this sheet has none.
 *
 * `aside` is an optional note parked past the right-hand tick (e.g. a hint).
 */
export default function Dimension({ label, aside, className = "" }) {
  return (
    <div className={`dim ${className}`.trim()} aria-hidden="true">
      <span className="dim-tick" />
      <span className="dim-rule" />
      <span className="dim-label">{label}</span>
      <span className="dim-rule" />
      <span className="dim-tick" />
      {aside ? <span className="dim-aside">{aside}</span> : null}
    </div>
  );
}

/**
 * One station of a dimension chain: the step number in a box, then the rule
 * running on to the next station. `last` terminates the chain with a tick.
 */
export function ChainNode({ n, last = false }) {
  return (
    <div className="chain-node" aria-hidden="true">
      <span className="node">{n}</span>
      <span className="seg" />
      {last && <span className="dim-tick" />}
    </div>
  );
}
